import { QuickActionTile } from '@/components/ui/QuickActionTile';
import { actionsFor } from '@/features/quick-actions/actions';
import { DashCard } from './DashCard';

/**
 * Quick Actions — docs/design/dashboard region 10, at the end of the page in
 * the proposal's size (64px tiles). Not pinned: on a 125%-scaled laptop it is
 * below the fold, and that is fine — the same actions are one step away from
 * every screen through the topbar ⚡ menu (Alt+Q, Alt+1..9) and the Ctrl+K
 * palette (QuickActions_Options.html, options B + C; features/quick-actions/).
 */
export function QuickActionsCard({ modules, onNavigate }: { modules: readonly string[]; onNavigate: (mod: string) => void }) {
  const visible = actionsFor(modules);
  if (!visible.length) return null;
  return (
    <DashCard title="Quick Actions" className="py-3">
      <div className="mt-2.5 grid grid-cols-3 gap-3 sm:grid-cols-5 xl:grid-cols-9">
        {visible.map(a => {
          const Icon = a.icon;
          return <QuickActionTile key={a.id} label={a.label} tone={a.tone} icon={<Icon className="h-[26px] w-[26px]" />} onClick={() => onNavigate(a.mod)} />;
        })}
      </div>
    </DashCard>
  );
}
